import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { DatePicker } from "react-rainbow-components";
import { toast } from "react-toastify";
import "./facturacionModal.css";
import { getFacturaPublica } from "../../../service/api";

export default class GenerarFacturaModal extends React.Component {
    state = {
        selectedRowId: null,
        q: "",
        fecha: "",
        loadingFecha: false,
        dataLocal: [],
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.setState(
                {
                    selectedRowId: null,
                    q: "",
                    fecha: this.props.fecha || "",
                    dataLocal: Array.isArray(this.props.data) ? this.props.data : [],
                    loadingFecha: false,
                }
            );
        }
    }

    toISODate = (dateObj) => {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };

    parseISOToDate = (iso) => {
        if (!iso) return new Date();
        const [y, m, d] = String(iso).split("-").map(Number);
        return new Date(y, (m || 1) - 1, d || 1);
    };

    money = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    normalizeText = (v) =>
        String(v ?? "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    getRowId = (row, idx) => {
        return `${row?.afiliacion}-${idx}`;
    };

    closemodal = () => {
        if (this.props.loading || this.state.loadingFecha) return;
        this.props.onClose && this.props.onClose();
    };

    onSelectRow = (rowId) => {
        this.setState({ selectedRowId: rowId });
    };

    onFacturar = (row, rowId, e) => {
        e.stopPropagation();

        this.setState({ selectedRowId: rowId }, () => {
            if (this.props.onFacturar) {
                this.props.onFacturar(row, this.state.fecha);
            }
        });
    };

    getFiltered = () => {
        const rows = Array.isArray(this.state.dataLocal) ? this.state.dataLocal : [];
        const q = this.normalizeText(this.state.q).trim();

        if (!q) return rows;

        return rows.filter((r) =>
            [
                r.afiliacion,
                r.banco,
                r.compania,
                r.cuenta,
                r.comentarios,
                r.moneda,
            ]
                .map(this.normalizeText)
                .join(" ")
                .includes(q)
        );
    };

    consultarFecha = async (fechaISO) => {
        try {
            this.setState({
                loadingFecha: true,
                selectedRowId: null,
            });

            const resp = await getFacturaPublica({ fecha: fechaISO });

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                this.setState({
                    dataLocal: [],
                    loadingFecha: false,
                });
                toast.info(resp?.message || "No fue posible consultar la fecha seleccionada.");
                return;
            }

            const arr = Array.isArray(resp?.data) ? resp.data : [];

            if (arr.length === 0) {
                this.setState({
                    dataLocal: [],
                    loadingFecha: false,
                });
                toast.info("No hay pendientes de facturación.");
                return;
            }

            this.setState({
                dataLocal: arr,
                loadingFecha: false,
            });
        } catch (e) {
            this.setState({
                dataLocal: [],
                loadingFecha: false,
            });
            toast.info("Error al consultar factura pública.");
        }
    };

    onChangeFecha = (dateObj) => {
        if (!dateObj) return;
        const fechaISO = this.toISODate(dateObj);

        this.setState(
            {
                fecha: fechaISO,
            },
            () => this.consultarFecha(fechaISO) 
        );
    };

    setHoy = () => {
        const hoyISO = this.toISODate(new Date());
        this.setState(
            {
                fecha: hoyISO,
            },
            () => this.consultarFecha(hoyISO)
        );
    };

    refreshFecha = () => {
        if (!this.state.fecha) return;
        this.consultarFecha(this.state.fecha);
    };

    render() {
        const { show, loading } = this.props;
        const { loadingFecha, fecha } = this.state;
        const rows = this.getFiltered();
        const disabledAll = loading || loadingFecha;

        return (
            <Modal
                isOpen={!!show}
                size="lg"
                centered
                toggle={this.closemodal}
                className="gf-modal"
            >
                <ModalBody className="gf-modalBody">
                    <div className="gf-header">
                        <h4 className="gf-title">Generar factura</h4>

                        <button
                            className="gf-close"
                            onClick={this.closemodal}
                            disabled={disabledAll}
                            type="button"
                        >
                            ×
                        </button>
                    </div>

                    <div className="gf-content">
                        <div className="gf-dateLabel">Facturas disponibles al</div>

                        <div className="gf-topbar">


                            <div className="gf-date">
                                <button
                                    type="button"
                                    className="gf-btnHoy"
                                    onClick={this.setHoy}
                                    disabled={disabledAll}
                                    title="Fecha actual"
                                >
                                    Hoy
                                </button>

                                <DatePicker
                                    id="facturacion-modal-date"
                                    value={fecha ? this.parseISOToDate(fecha) : null}
                                    onChange={this.onChangeFecha}
                                    formatStyle="large"
                                    placeholder="Selecciona fecha"
                                    disabled={disabledAll}
                                />

                            </div>

                            <div className="gf-search">
                                <span>🔎</span>
                                <input
                                    value={this.state.q}
                                    onChange={(e) => this.setState({ q: e.target.value })}
                                    placeholder="Buscar afiliación, banco, compañía..."
                                    disabled={disabledAll}
                                />

                                {this.state.q && (
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ q: "" })}
                                        disabled={disabledAll}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="gf-tableWrap">
                            <table className="gf-table">
                                <thead>
                                    <tr>
                                        <th>Afiliación</th>
                                        <th>Moneda</th>
                                        <th>Banco</th>
                                        <th>Compañía</th>
                                        <th>Cuenta</th>
                                        <th>Pagos</th>
                                        <th>Total</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="gf-empty">
                                                No hay pendientes de facturación
                                            </td>
                                        </tr>
                                    ) : (
                                        rows.map((r, idx) => {
                                            const id = this.getRowId(r, idx);
                                            const active = this.state.selectedRowId === id;

                                            return (
                                                <tr
                                                    key={id}
                                                    className={active ? "gf-row-active" : ""}
                                                    onClick={() => this.onSelectRow(id)}
                                                >
                                                    <td className="gf-mono">{r.afiliacion}</td>
                                                    <td>{r.moneda}</td>
                                                    <td>{r.banco}</td>
                                                    <td>{r.compania}</td>
                                                    <td>{r.cuenta}</td>
                                                    <td className="gf-num">{r.pagos}</td>
                                                    <td className="gf-num gf-bold">
                                                        {this.money(r.total)}
                                                    </td>

                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <button
                                                            className="gf-btnFacturar"
                                                            onClick={(e) => this.onFacturar(r, id, e)}
                                                            disabled={disabledAll}
                                                            type="button"
                                                        >
                                                            Facturar
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}